import { useEffect } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { toast } from 'sonner'
import { useAcceptInviteQuery } from '~/graphql/hooks/useAcceptInviteQuery'
import { storage } from '~/utilities/storageUitls'

import { XIcon } from 'lucide-react'
import Loading from '~/components/ui/Loading'

export default function AcceptInvite() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const inviteToken = searchParams.get('token') ?? ''
  const { acceptInvite, loading } = useAcceptInviteQuery(inviteToken)

  /**
   * Goals:
   * Handle the following actions: accept, login, register
   *
   * login:
   * should clear out existin logged in user and then redirect to the login page
   *
   * register:
   * should clear out existin logged in user and then redirect to the register page
   *
   * accept:
   * should see the user
   *
   */

  useEffect(() => {
    if (loading) return

    if (!acceptInvite?.inviteToken || loading) {
      toast.error(
        <div className="flex items-center gap-4">
          <XIcon size={16} className="text-destructive font-semibold" />
          <p>
            <span className="font-semibold">This invitation is invalid.</span>
            <br />
            Please request a new one.
          </p>
        </div>,
        {
          onAutoClose: () => {
            navigate('/login')
          }
        }
      )
    }

    if (acceptInvite?.action === 'accept' && !loading) {
      navigate('/org')
      return
    }

    if (acceptInvite?.action === 'login' && !loading) {
      storage.clear()
      window.localStorage.setItem('invite_token', inviteToken)
      navigate('/login')
      return
    }

    if (acceptInvite?.action === 'register' && !loading) {
      storage.clear()
      window.localStorage.setItem('invite_token', inviteToken)
      navigate('/register')
      return
    }
  }, [acceptInvite, navigate, loading, inviteToken])

  return <Loading />
}
